import { render, staticRenderFns } from "./FacultyHeader.vue?vue&type=template&id=68a1f5b2&"
import script from "./FacultyHeader.vue?vue&type=script&lang=js&"
export * from "./FacultyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports